import { Button } from "@heroui/react";
import { motion } from "framer-motion";
import { LuCircleAlert } from "react-icons/lu";

const ErrorState = ({
    title = "Something went wrong",
    description = "We couldn't load the data. Please try again later.",
    icon,
    actionLabel = "Try Again",
    onAction,
}) => {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center p-8 text-center">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative mb-6"
            >
                {/* Glow Effect */}
                <div className="from-danger/20 to-warning/20 absolute inset-0 bg-linear-to-tr blur-2xl filter" />

                {/* Icon */}
                <div className="text-danger-500 relative">
                    {icon || <LuCircleAlert size={64} strokeWidth={1.5} />}
                </div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="max-w-xs"
            >
                <h3 className="text-default-700 text-lg font-semibold">
                    {title}
                </h3>
                <p className="text-default-500 mt-2 text-sm leading-relaxed">
                    {description}
                </p>
            </motion.div>

            {onAction && actionLabel && (
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                    className="mt-6"
                >
                    <Button color="danger" variant="flat" onPress={onAction}>
                        {actionLabel}
                    </Button>
                </motion.div>
            )}
        </div>
    );
};

export default ErrorState;
